import { Injectable } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SignupService {

  signUpUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'sign-up'}`;

  constructor(private readonly http: HttpClient) { }


  signUp(data:any){
    return this.http.post(this.signUpUrl, data);
  }

} 